import HttpMethodType from "HttpMethodType";
import SubSystemType from "SubSystemType";
import BaseServiceRequest from "BaseServiceRequest";

class SetAiInsightsTextReactions extends BaseServiceRequest {
  constructor(data) {
    super();
    super.addRequestUri("aiInsights/feedback");
    const reqData = {};
    reqData.ai_report_type_id = data.aiReportTypeId;
    reqData.OSID = data.OSID;
    reqData.reactions = data.reactions;
    super.setContent(JSON.stringify(reqData));
  }

  getMethod() {
    return HttpMethodType.POST;
  }

  getSubSystem() {
    return SubSystemType.GRAPH;
  }
}

export default SetAiInsightsTextReactions;
